import React from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { isLogin } from './../../utils/authentication.js';
import axios from 'axios';
import Navbar from './../Navbar/navbar.jsx';
import Navigation from './../Navigation/navigation.jsx';
import Pusher from 'pusher-js';
import { Button, Spinner, ProgressBar, Accordion, Card, useAccordionToggle } from 'react-bootstrap';

import { BACKEND_URL_MAIN as BACKEND_URL } from '../../config.js';


// Pusher.logToConsole = true;

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionToggle(eventKey, () =>
    console.log('totally custom!'),
  );

  return (
    <button
      type="button"
      className="btn btn-primary"
      style={{ cursor: 'pointer', float: 'right' }}
      onClick={decoratedOnClick}
    >
      {children}
    </button>
  );
}

class Scrappers extends React.PureComponent {

  state = {
    isDisabled: true,
    conent: null,
    liveStatus: null,
    process: 0,
    smartResponse: null,
    url: 'https://docs.google.com/spreadsheets/d/1-TMfNPxb1Ph2w9I1M_fNPfwQ8gZd6WB9OKcM-3rBTqY/edit?ts=5f215518#gid=102110434',
    type: 'PrecisionMedicine'
  }

  componentDidMount(){

     if(!isLogin()){
          this.props.history.push({
              pathname:"/login"
          });
      }

    this.getInsightContent()


    var pusher = new Pusher('143db21116755d77f805', {
      cluster: 'ap2',
      forceTLS: true
    });

    var channel = pusher.subscribe('scrapper');
    channel.bind('key-developments', (data)=> {
      this.setState({ liveStatus: data.message, process: data.process, smartResponse: data.smartResponse })
      console.log(data);
    });


  }

  getInsightContent = () => {

    axios.get(
        BACKEND_URL + "/v1/insights/content"
      ).then((res) => {
        this.setState({content: res.data, isDisabled: false})
      }).catch((err) => {
        console.log(err)
      }
    )
  }

  handleChange = (e)=> {
    this.setState({ url: e.target.value })
  }

  onTypeChanged = (e)=> {
    this.setState({
      type: e.currentTarget.value
    });
  }

  handleSave = ()=> {
    let url = this.state.url
    let conf = confirm("Are you sure this is for " + this.state.type)
    if(conf) {
      if(url.length > 38){
        url = url.split('/')[5]
        console.log(url)
        axios.post(
          BACKEND_URL + "/v1/scrappers/keydevelopments", {
              url: url,
              type: this.state.type
          }, {
              headers: {
                  token: localStorage.getItem("token")
              }
          }
        ).then((res) => {
            console.log(res)
        }).catch((err) => {
            console.log(err)
        })
      } else {
        alert('Invalid URL')
      }
    }
  }


  render() {
    const { smartResponse, content } = this.state;
    console.log(this.state.url)
    return (
      <div>
        <div className="col-md-12 topbar">
            <Navbar />
        </div>


        <main role="main" className="container">
          <div className="my-3 p-3 bg-white rounded shadow-sm">
            <h6 className="border-bottom border-gray pb-2 mb-0">BIS Workspace</h6>
            <div className="card">
              <div className="card-body">
              <h5 className="card-title">Key Developments Scrapper</h5>
                <div className="d-flex">
                  {content && content.feedList && content.feedList.map((o, index)=>
                    <div key={index} className="mr-4">
                      <label className="mr-2">{o.industry_name}</label>
                      <input type="radio"
                         value={o.industry_type}
                         checked={this.state.type === o.industry_type} 
                         onChange={this.onTypeChanged} />
                    </div>
                  ) }
                </div>
                <div className="form-group">
                  <label style={{color: '#0007d4'}}>Google Spreadsheets URL</label>
                  <input onChange={this.handleChange} defaultValue={this.state.url} className="form-control" placeholder="https://docs.google.com/spreadsheets/d/17zsBYpZ4Jmi0yIDfmnHm4q7HdOMIx8kkLGkUwF6rIqI/edit#gid=102110434" />
                  
                </div>
                <Spinner animation="grow" />
                { this.state.process !== 0  &&  <ProgressBar animated now={this.state.process} /> }
                { this.state.process !== 0 && <small style={{color: '#037cff', fontSize: 15 }} className="form-text text-center">{this.state.liveStatus}</small> }
                { this.state.process === 100 || this.state.process === 0  ? <Button variant="primary" disabled={this.state.isDisabled} onClick={this.handleSave} >{this.state.process == 100 ? 'Submit Again' : 'Submit'}</Button> :  null }
              </div>
              { this.state.smartResponse &&
                <Accordion style={{padding: 10}}>
                  <b style={{color: 'red'}}>SMART RESPONSE</b>
                  <Card style={{marginBottom: 5}}>
                    <Card.Header style={{padding: 5}}>
                      <b>Saved Records</b>:  {smartResponse.savedRecords } out of { smartResponse.totalRecords }
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>Hello! I'm the body</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                  <Card style={{marginBottom: 5}}>
                    <Card.Header style={{padding: 5}}>
                      <b>Company Name Not Match</b>:  {smartResponse.idsNotAvailable.length} out of { smartResponse.companiesFound }
                      <CustomToggle eventKey="1">Show Details</CustomToggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="1">
                      <Card.Body>
                        <ul className="list-group">
                          { smartResponse.idsNotAvailable && smartResponse.idsNotAvailable.map((data, index) =>
                            <li key={index} className="list-group-item"><b>{index+1}</b>: {data}</li>
                          )}
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                  <Card style={{marginBottom: 5}}>
                    <Card.Header style={{padding: 5}}>
                      <b>Wrong Topics</b>:  {smartResponse.topics.wrong} out of {smartResponse.savableRecors}
                      <CustomToggle eventKey="2">Show Details</CustomToggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="2">
                      <Card.Body>
                        <ul className="list-group">
                          { smartResponse.topics.data && smartResponse.topics.data.map((data, index) =>
                            <li key={index} className="list-group-item"><b>{index}</b>: {data}</li>
                          )}
                        </ul>
                      </Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion>
              }
            </div>
              <small>1. Must be public google sheet:  <b>Share -> Advanced -> Who has access ( Public on the web - Anyone on the Internet can find and view  ) </b></small>
              <br />
              <small>2. Sheet Format:  <b>https://docs.google.com/spreadsheets/d/17zsBYpZ4Jmi0yIDfmnHm4q7HdOMIx8kkLGkUwF6rIqI/edit#gid=102110434</b></small>
              
          </div>
        </main>
      </div>
    );
  }
}

function mapStateToProps(state){
    return { }
}

export default withRouter(connect(
  mapStateToProps
)(Scrappers))




// WEBPACK FOOTER //
// ./src/components/Insights/Scrappers.js